import React, { useState } from 'react'
import clsx from 'clsx';
import { EmojiEmotions as EmojiEmotionsIcon } from '@mui/icons-material';
import { Icon, IconButton } from '@mui/material';
import EmojiModal from './EmojiModal';
import smiley from '../../assets/img/smiley.svg';

function EmojiSelector({
  className,
  positionClassName,
  onSelection,
}) {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  return (
    <div className={clsx(className ?? 'absolute', positionClassName ?? 'top-2 right-1')}>
      <IconButton onClick={handleClick}>
        <Icon>
          <img src={smiley} />
        </Icon>
      </IconButton>

      <EmojiModal
        open={open}
        onClose={handleClose}
        onSelection={onSelection}
      />
    </div>
  )
}

export default EmojiSelector;